/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class CoreActionKey {
  static readonly CREATE = 'kit-core/action/create';
  static readonly EDIT = 'kit-core/action/edit';
  static readonly DELETE = 'kit-core/action/delete';
  static readonly ADD = 'kit-core/action/add';
  static readonly REMOVE = 'kit-core/action/remove';
  static readonly LOAD = 'kit-core/action/load';
  static readonly SAVE = 'kit-core/action/save';
  static readonly DISCARD = 'kit-core/action/discard';
  static readonly SAVE_CHANGES = 'kit-core/action/save-changes';
  static readonly DISCARD_CHANGES = 'kit-core/action/discard-changes';
  static readonly CONTINUE = 'kit-core/action/continue';
  static readonly NEXT = 'kit-core/action/next';
  static readonly BACK = 'kit-core/action/back';
  static readonly START = 'kit-core/action/start';
  static readonly STOP = 'kit-core/action/stopp';
  static readonly CANCEL = 'kit-core/action/cancel';
  static readonly ABORT = 'kit-core/action/abort';
  static readonly CLOSE = 'kit-core/action/close';
  static readonly END = 'kit-core/action/end';
  static readonly LOGIN = 'kit-core/action/login';
  static readonly LOGOUT = 'kit-core/action/logout';
  static readonly REGISTER = 'kit-core/action/register';
  static readonly RESET_PASSWORD = 'kit-core/action/reset-password';
}
